import { map } from 'rxjs/operators';

const getBrowseConfig = apiClient => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse`;
  return apiClient.get(route);
};

const getBrowseCategoryConfig = (apiClient, categoryId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse/categories${categoryId}`;
  return apiClient.get(route);
};

const getCategoryConfig = (apiClient, categoryConfigId) => {
  const serializeddCategoryConfigId = encodeURIComponent(categoryConfigId);
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse/categoryConfigs/${serializeddCategoryConfigId}`;

  return apiClient.get(route).pipe(
    map(response => {
      return response.body;
    })
  );
};

const getCategoryConfigs = (apiClient, topLevelCategoryId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse/categoryConfigs`;

  return apiClient.get(route, { query: { topLevelCategoryId } }).pipe(
    map(response => {
      return response.body || {};
    })
  );
};

const saveCategoryConfig = (apiClient, categoryConfig) => {
  const { categoryConfigId } = categoryConfig;
  const serializeddCategoryConfigId = encodeURIComponent(categoryConfigId);
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse/categoryConfigs/${serializeddCategoryConfigId}`;

  return apiClient.post(route, categoryConfig).pipe(
    map(response => {
      return response.body;
    })
  );
};

export { getBrowseConfig, getBrowseCategoryConfig, getCategoryConfig, getCategoryConfigs, saveCategoryConfig };
